<section class="guarantees" *appHasPermission="financialInstitutionPermissions.MODULE">
  <div class="guarantees-head">
    <h1 class="title">{{ tk.Management.FinancialInstitution | t }}</h1>
    <p class="subtitle">Visualize e gerencie as instituições financeiras cadastradas.</p>
  </div>

  <div class="guarantees-actions">
    <ng-container *appHasPermission="financialInstitutionPermissions.CREATE">
      <app-button
        [id]="'add-group'"
        [label]="tk.User.ToAdd | t"
        [icon]="'pi pi-plus'"
        [type]="'button'"
        (sendButtonClick)="addFinancialInstitution()"></app-button>
    </ng-container>
  </div>

  <app-table
    [hasFilter]="false"
    [reorderableColumns]="true"
    [title]="'Instituições Financeiras'"
    [subtitle]="''"
    [resizableColumns]="true"
    [sortable]="true"
    [hasPagination]="true"
    [totalRecords]="pagination.total"
    [items]="financialInstitutions"
    [loading]="loading"
    [showSearch]="true"
    [columnDefinitions]="columnDefinitions"
    [rows]="pagination.itemsPerPage || 10"
    [getOptionsFunction]="getMenuActions.bind(this)"
    (sendTablePagination)="handleTablePagination($event)"
    (sendTableAction)="handleTableAction($event)"
    (sendTableFilter)="handleSearch($event)">
    <ng-template appNamedTemplate="logo" let-item>
      <app-bank-logo [institution]="item" />
    </ng-template>
  </app-table>
</section>

<!-- Modal de Gerentes Bancários -->
<app-modal-bank-managers
  #bankManagersModal
  [financialInstitutionId]="selectedFinancialInstitutionId"
  [financialInstitutionName]="selectedFinancialInstitutionName"
  (modalClosed)="onBankManagersModalClosed()"></app-modal-bank-managers>
